let url = '';
    // (window.location.hostname === 'localhost.bma-dev.tovdoruk.com') ? '//bma-dev.tovdoruk.com' : '';

export const API_PREFIX = process.env.NODE_ENV === 'development' ? url : '';
